/**
 * Role home for signed-in users. Used by the logo, homepage redirect, and middleware.
 * Fallback is /student so authenticated users are never sent back to / (which would loop).
 */
export function getDashboardPath(role: string | null | undefined): string {
  const roleUpper = role?.toUpperCase() ?? "";
  if (roleUpper.includes("ADMIN")) return "/admin/dashboard";
  if (roleUpper.includes("ADVERTISER")) return "/advertiser/dashboard";
  if (roleUpper.includes("TUTOR")) return "/tutor";
  if (roleUpper.includes("STUDENT")) return "/student";
  if (roleUpper.includes("CANDIDATE")) return "/applications";
  if (roleUpper.includes("EMPLOYEE")) return "/employee/dashboard";
  return "/student";
}
